const baseJson = () => {
  return {
    _id: null,
    name: null,
    tenGoi: null,
    tenGoiEn: null,
    chuDe: null,
    chuDeEn: null,
    thoiGian: null,
    thoiGianEn: null,
    diaDiem: null,
    diaDiemEn: null,
    quyMo: null,
    quyMoEn: null,
    hinhAnh: [],
    isPublic: false,
  };
};

const toJson = (item) => {
  if (!item) return baseJson();

  return {
    _id: item._id,
    name: item.name || null,
    tenGoi: item.tenGoi || null,
    tenGoiEn: item.tenGoiEn || null,
    chuDe: item.chuDe || null,
    chuDeEn: item.chuDeEn || null,
    thoiGian: item.thoiGian || null,
    thoiGianEn: item.thoiGianEn || null,
    diaDiem: item.diaDiem || null,
    diaDiemEn: item.diaDiemEn || null,
    quyMo: item.quyMo || null,
    quyMoEn: item.quyMoEn || null,
    hinhAnh: Array.isArray(item.hinhAnh)
      ? item.hinhAnh.map((img) => ({
          fileId: img.fileId || null,
          fileName: img.fileName || null,
          ext: img.ext || null,
          path: img.path || null,
        }))
      : [],
    isPublic: item.isPublic === true,
  };
};

const fromJson = (item) => {
  if (!item) return baseJson();
  return {
    _id: item._id,
    name: item.name || null,
    tenGoi: item.tenGoi || null,
    tenGoiEn: item.tenGoiEn || null,
    chuDe: item.chuDe || null,
    chuDeEn: item.chuDeEn || null,
    thoiGian: item.thoiGian || null,
    thoiGianEn: item.thoiGianEn || null,
    diaDiem: item.diaDiem || null,
    diaDiemEn: item.diaDiemEn || null,
    quyMo: item.quyMo || null,
    quyMoEn: item.quyMoEn || null,
    hinhAnh: Array.isArray(item.hinhAnh) ? item.hinhAnh : [],
    isPublic: item.isPublic === true,
  };
};

export const siteInfoModel = {
  baseJson,
  fromJson,
  toJson,
};
